import React from "react";
import type { CompanyType } from "../../types/participantsTypes";
import { Card, Typography, Tag, Row, Col, Image, Space ,Descriptions, Divider } from "antd";
const VITE_API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

type CompanyProps = {
    company: CompanyType;
};

const CompanyCard: React.FC<CompanyProps> = ({ company }) => {
    const statusMap = {
        1: { color: "green", label: "Active" },
        2: { color: "red", label: "Inactive" },
        //3: { color: "orange", label: "Draft" },
    } as const;

    const { color: statusColor, label: statusLabel } =
        statusMap[company.status as 1 | 2 ] || { color: "default", label: "Unknown" };

    
    const logoUrl = typeof company.logo === "string" ? `${VITE_API_BASE_URL.replace(/api$/, '')}${company.logo }`  : "";


    return (
        <Card bordered={false} hoverable>
            <Row gutter={[24, 24]} align="middle">

                <Col xs={24} md={6} style={{ textAlign: "center" }}>
                    <Space
                        direction="vertical"
                        align="center"
                        size="middle"
                        style={{ width: "100%" }}
                    >
                         {/*Name */}
                        <Typography.Title level={3} style={{ margin: 0 }}>
                            {company.name}
                        </Typography.Title>

                         {/*Logo */}
                        <Image
                            src={logoUrl}
                            alt={`${company.name} Logo`}
                            width={150}
                            height={150}
                            preview={true}
                        />

                         {/*Status */}
                        <Tag color={statusColor}>{statusLabel}</Tag>
                    </Space>
                </Col>


                {/* Main Info */}
                <Col xs={24} md={18}>
                    <Descriptions
                        bordered
                        column={1}
                        size="middle"
                    >
                        <Descriptions.Item label={<Typography.Text strong>Phone</Typography.Text>}>
                            {company.phoneNo || "N/A"}
                        </Descriptions.Item>
                        <Descriptions.Item label={<Typography.Text strong>Mobile No</Typography.Text>}>
                            {company.mobileNo || "N/A"}
                        </Descriptions.Item>
                        <Descriptions.Item label={<Typography.Text strong>Email</Typography.Text>} >
                            {company.email || "N/A"}
                        </Descriptions.Item>
                    </Descriptions>
                </Col>
            </Row>

            <Divider />

            {/* Extra Info */}
            <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} md={8}>
                    <Card bordered hoverable size="small" className="h-24 overflow-auto rounded-lg">
                        <p><strong>Country:</strong> {company.country || "N/A"}</p>
                    </Card>
                </Col>
                <Col xs={24} sm={12} md={8}>
                    <Card bordered hoverable size="small" className="h-24 overflow-auto rounded-lg">
                        <p><strong>City:</strong> {company.city || "N/A"}</p>
                    </Card>
                </Col>
                <Col xs={24} sm={12} md={8}>
                    <Card bordered hoverable size="small" className="h-24 overflow-auto rounded-lg">
                        <p><strong>Address:</strong> #{company.address || "N/A"}</p>
                    </Card>
                </Col>
            </Row>
        </Card>
    );
};

export default CompanyCard;
